import { UseFormRegister } from "react-hook-form";
import { CertificateAreaField } from "./CertificateAreaField";

/**
 * The four rows of "Deductions in Plot Area" on the Bahadura certificate,
 * under the names the backend saves (cp_saved_certificate_data). Each is a
 * number in sq. mt.; Deduction in Plot Area stays its own field.
 */
export const CERTIFICATE_DEDUCTION_ROWS = [
  { name: "deductionUnderRoadWidening", label: "Under Road Widening [sq. mt.]" },
  { name: "deductionUnderRoadCurvature", label: "Under Road Curvature [sq. mt.]" },
  { name: "deductionUnderDpRoadTowerLine", label: "Under D.P. Road / Tower line [sq. mt.]" },
  { name: "deductionOutsideKPrat", label: "Outside 'K' prat [sq. mt.]" },
] as const;

/** Starting values for a form that has nothing saved yet. */
export const CERTIFICATE_DEDUCTION_DEFAULTS = {
  deductionUnderRoadWidening: 0,
  deductionUnderRoadCurvature: 0,
  deductionUnderDpRoadTowerLine: 0,
  deductionOutsideKPrat: 0,
};

/**
 * The four deduction inputs with a heading, for the L1, L2 and L3
 * certificate forms, so the three copies cannot drift apart.
 */
export function CertificateDeductionRows({ register }: { register: UseFormRegister<any> }) {
  return (
    <>
      <div className="col-span-2 pt-2">
        <p className="text-base font-bold text-[#423F3F]">Deductions in Plot Area</p>
      </div>
      {CERTIFICATE_DEDUCTION_ROWS.map((row) => (
        <CertificateAreaField key={row.name} label={row.label} name={row.name} register={register} />
      ))}
    </>
  );
}
